import { render, staticRenderFns } from "./Cargando.comp.vue?vue&type=template&id=c1b291ba&scoped=true&"
import script from "./Cargando.comp.vue?vue&type=script&lang=js&"
export * from "./Cargando.comp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b291ba",
  null
  
)

export default component.exports